import React from 'react';

import { Paper, PaperProps, Space, Text, UnstyledButton, useMantineTheme } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ROUTE_LINKS } from 'shared/constants/route-links';

interface BackButtonProps extends PaperProps {
  to?: string;
  preNavigate?: () => void;
  onClick?: () => void;
  disabled?: boolean;
}

export function BackButton({ to, preNavigate, onClick, disabled, ...paperProps }: BackButtonProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const theme = useMantineTheme();

  const bgColor = paperProps.bg || theme.colors.gray[0];
  const color = theme.other.getReadableColor(bgColor);
  const dimmedColor = theme.other.getDimmedColor(bgColor);

  return (
    <UnstyledButton>
      <Paper
        {...paperProps}
        onClick={() => {
          if (disabled) return;
          preNavigate?.();
          to ? navigate(to) : navigate(ROUTE_LINKS.back);
          onClick?.();
        }}
        p={'5px 8px'}
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row',
          borderColor: dimmedColor,
          '&:hover': {
            backgroundColor: dimmedColor,
            cursor: 'pointer'
          }
        }}>
        <IconArrowLeft color={color} />
        <Space w={5} />
        <Text color={color} weight={600}>
          {t('APP.ACTIONS.BACK')}
        </Text>
      </Paper>
    </UnstyledButton>
  );
}
